import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ViewEncapsulation,
  OnDestroy,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import { SwiperOptions } from 'swiper/types';

@Component({
  selector: 'app-swiper-wrapper',
  template: `
    <swiper-container
      init="false"
      #swiperContainer
      style="display: block; width: 100%; height: 100%;"
    >
      <ng-content></ng-content>
    </swiper-container>
  `,
  encapsulation: ViewEncapsulation.None,
})
export class SwiperWrapperComponent
  implements AfterViewInit, OnDestroy, OnChanges
{
  @Input() config: SwiperOptions;
  @Output() swiper = new EventEmitter<any>();

  @ViewChild('swiperContainer') swiperContainer!: ElementRef;

  constructor() {}

  ngAfterViewInit() {
    this.initSwiper();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['config'] && !changes['config'].isFirstChange()) {
      this.updateSwiper();
    }
  }

  initSwiper() {
    if (this.swiperContainer && this.swiperContainer.nativeElement) {
      const swiperEl = this.swiperContainer.nativeElement;

      // Assign parameters
      if (this.config) {
        Object.assign(swiperEl, this.config);
      }

      // Initialize
      if (swiperEl.initialize) {
        swiperEl.initialize();
      } else {
        // Fallback: wait for custom element to be defined if it's not yet
        // customElements.whenDefined('swiper-container').then(() => swiperEl.initialize());
        // Or it might be that init attribute is not false? No, we set init="false".
        // The element might not be upgraded yet.
        console.warn(
          'Swiper element not initialized yet, waiting for upgrade...'
        );
        // We can try to rely on the fact that register() calls will upgrade it eventually
      }

      // Emit swiper instance
      // We check immediately, and also set a small timeout just in case it's not ready synchronously
      if (swiperEl.swiper) {
        this.swiper.emit(swiperEl.swiper);
      } else {
        setTimeout(() => {
          if (swiperEl.swiper) {
            this.swiper.emit(swiperEl.swiper);
          }
        }, 0);
      }
    }
  }

  updateSwiper() {
    if (
      this.swiperContainer &&
      this.swiperContainer.nativeElement &&
      this.swiperContainer.nativeElement.swiper
    ) {
      // Dynamic updates if needed, though usually re-assigning params works
      const swiperEl = this.swiperContainer.nativeElement;
      if (this.config) {
        Object.assign(swiperEl, this.config);
        swiperEl.swiper.update();
      }
    }
  }

  ngOnDestroy() {
    // Cleanup if necessary? Swiper Element handles its own cleanup usually.
  }
}
